<template>
  <form
    class="form-time-range"
    v-on:submit.prevent="onSubmit">
    <time-interval-picker
      v-bind:initial-from="from"
      v-bind:initial-to="to"
      v-bind:time-set="suggestionHours"
      v-on:input-from="changeFrom"
      v-on:input-to="changeTo"
      class="form-time-range__row"
    />
    <div class="form-time-range__buttons">
      <button
        class="form-time-range__cancel"
        type="button"
        v-on:click="onClose">Отмена</button>
      <button
        class="form-time-range__submit"
        type="submit">ОК</button>
    </div>
  </form>
</template>
<script>
import { builtInPopoverMixin } from '@/mixins/builtInPopoverMixin';
import TimeIntervalPicker from '@/components/TimeIntervalPicker.vue';
/**
 * @description Компонент формы временного диапазона дня.
 * @type {Vue}
 */
export default {
  components: { TimeIntervalPicker },
  data() {
    return {
      from: this.initialFrom || '00:00',
      to: this.initialTo || '00:00',
    };
  },
  maskTime: '##:##',
  methods: {
    onSubmit() {
      this.$emit('submit', this.from, this.to, this.closePopover);
    },
    onClose() {
      this.closePopover();
      this.$emit('close-change-work-time-popover');
    },
    changeFrom(value) {
      this.from = value;
    },
    changeTo(value) {
      this.to = value;
    },
  },
  mixins: [builtInPopoverMixin],
  name: 'FormDailyTimeRange',
  props: {
    /**
     * @description Время начала.
     * @type {string}
     */
    initialFrom: { type: String, default: '' },
    /**
     * @description Время окончания.
     * @type {string}
     */
    initialTo: { type: String, default: '' },
    /**
     * @description Предлагаемый набор часов.
     * @type {string[]}
     */
    suggestionHours: {
      default: () => [],
      required: false,
      type: Array,
    },
  },
  watch: {
    initialFrom(value) {
      this.from = value || '00:00';
    },
    initialTo(value) {
      this.to = value || '00:00';
    },
  },
};
</script>
<style lang="scss" scoped>
@use "@/scss/buttons";
$button-font-size: 14px;
$button-height: 37px;
$button-width: 100%;

.form-time-range {
  padding: 30px 22px;
  width: 300px;
  max-width: 99%;
  &__row {
    display: grid;
    grid-template-columns: 1fr 10px 1fr;
    grid-gap: 10px;
    align-items: center;
  }
  &__input {
    border: 1px solid #c2cfe0;
    box-sizing: border-box;
    border-radius: 4px;
    appearance: textfield;
    height: 40px;
    width: 100%;
    padding: 10px;
    color: #707683;
    font-size: 16px;
    &:focus {
      color: #192a3e;
      background-color: #fff;
      border: 1px solid #0489e0 !important;
      outline: 0;
    }
    &:disabled {
      background-color: #fff;
    }
  }
  &__buttons {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 6px;
    justify-content: flex-end;
    margin: 30px 0 0 0;
  }
  &__cancel {
    @include buttons.btn-transparent($button-width, $button-height, $button-font-size);
  }
  &__submit {
    @include buttons.btn-blue($button-width, $button-height, $button-font-size);
  }
}
</style>
